import React from 'react';

function classeESituacao(status, fallback) {
    if (!status) {
        return { classe: 'sol-badge--open', icone: 'fa-circle-dot', nome: fallback || 'Em aberto' };
    }
    const nome = (status.nome || '').trim() || fallback || 'Em aberto';
    if (Number(status.cancelamento) === 1) {
        return { classe: 'sol-badge--danger', icone: 'fa-ban', nome };
    }
    if (Number(status.conclusao) === 1) {
        return { classe: 'sol-badge--success', icone: 'fa-circle-check', nome };
    }
    if (Number(status.finalizacao) === 1) {
        return { classe: 'sol-badge--neutral', icone: 'fa-flag-checkered', nome };
    }
    return { classe: 'sol-badge--progress', icone: 'fa-spinner', nome };
}

function StatusBadge({ statusVal, statusList, fallback }) {
    const n = statusVal != null && statusVal !== '' ? Number(statusVal) : NaN;
    const status = !Number.isNaN(n) && Array.isArray(statusList)
        ? statusList.find((s) => Number(s.codigo_legado) === n || Number(s.id) === n)
        : null;
    const { classe, nome } = classeESituacao(status, fallback);
    return <span className={`sol-badge ${classe}`}>{nome}</span>;
}

export default StatusBadge;
